export default __webpack_public_path__ + "images/bda715791bcad3506d3e23ef617c7893-pyxir-greeting-2x.es.png";